import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-headledgerpage',
  templateUrl: './headledgerpage.component.html',
  styleUrls: ['./headledgerpage.component.sass']
})
export class HeadledgerpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
